import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'cw-icon',
    template: `
        <svg class="zp__icon">
            <use attr.xlink:href="/assets/base/img/icons.svg#{{svgId}}"/>
        </svg>
    `,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CwIconComponent {
    @Input()
    public svgId!: string;
}
